<template>
    <div class="stat-container">
        <div class="row px-3">
            <div class="col-2 pt-4">
                <span class="stat-title">{{ getMaterialReportUnitTranslationString(attribute) }}</span>
            </div>
            <div class="col-2 pt-4">
                <span class="stat-title">{{ $t('contract_reports.amount') }}</span>
            </div>
            <div class="col-2 pt-4">
                <span class="stat-title">{{ $t('contract_reports.unit') }}</span>
            </div>
        </div>
        <div class="row px-3">
            <div v-for="(material, index) in materialCombined" :key="index" class="col-12">
                <div class="row ">
                    <div class="col-2">
                        <span class="stat-text">{{ material[attribute] }}</span>
                    </div>
                    <div class="col-2">
                        <span class="stat-text">{{ material.amount }}</span>
                    </div>
                    <div class="col-2">
                        <span class="stat-text">{{ material.unit }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!hideButtons" class="col-12 d-flex justify-content-end my-2 px-3">
                <button class="btn btn-outline-success" @click.stop="$emit('showAddMaterialReport')">
                    <i class="fa fa-plus"/>
                </button>
                <button class="btn btn-outline-success mx-2" @click.stop="$emit('downloadMaterialReportExcel')">
                    {{ $t('common.download_excel') }}
                </button>
        </div>
    </div>
</template>

<script>

import {materialReportHelper} from "@/components/mixins/MaterialReportMixin";

export default {
    name: 'ContractMaterialSummaryValues',
    mixins: [materialReportHelper],
    props: {
        materialCombined: {
            type: Array,
            default: function () {
                return []
            }
        },
        attribute: {
            type: String,
            default: function () {
                return null
            }
        },
        hideButtons: {
            type: Boolean,
            default: function () {
                return false
            }
        }
    },

}

</script>

<style>
</style>
